import { useParams as useReactRouterParams } from 'react-router-dom'

export const useParams = useReactRouterParams

export default useParams
